// use when joining multiple variables whose values may or may not be strings
export const joinStrings = (array, concatenator = ' ') => array.filter(item => typeof (item) === 'string').join(concatenator);

// check array equality
export const arrayEquals = (a, b) => Array.isArray(a)
  && Array.isArray(b)
  && a.length === b.length
  && a.every((val, index) => val === b[index]);
